import { ComponentRendering, HtmlElementRendering } from '@sitecore-jss/sitecore-jss-nextjs';

const isComponentRendering = (o: any): o is ComponentRendering => 'componentName' in o;

/**
 * Finds the the component with name `componentName` in the tree `roots`.
 */
const findComponentInTree = <T>(
  roots?: (ComponentRendering | HtmlElementRendering)[],
  componentName?: string
): ComponentRendering<T> | undefined => {
  if (!roots) return undefined;
  for (const root of roots) {
    if (!isComponentRendering(root)) return undefined;
    if (root.componentName == componentName) {
      return root as ComponentRendering<T>;
    }

    const placeholders = Object.values(root.placeholders ?? {}).flatMap((p) => p);
    const result = findComponentInTree(placeholders, componentName);
    if (!!result) return result as ComponentRendering<T>;
  }
  return undefined;
};

export default findComponentInTree;
